import { styled } from '@material-ui/core';
import { ReactComponent as CheckboxCheckedIcon } from 'assets/icons/checkbox-checked.svg';
import { ReactComponent as CheckboxUnCheckedIcon } from 'assets/icons/checkbox-unchecked.svg';

export const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
});

const getCheckBoxColour = (variant, theme) => {
  switch (variant) {
    case 'secondary':
      return theme.palette.common.secondary;
    default:
      return theme.palette.common.primary;
  }
};

export const InputContainer = styled('div')(({ theme, variant, checked }) => ({
  width: '18px',
  height: '18px',
  position: 'relative',
  color: !checked
    ? theme.palette.common.ghost
    : getCheckBoxColour(variant, theme),
  '&[disabled]': {
    opacity: 0.5,
    pointerEvents: 'none',
  },
}));

export const InvisibleInput = styled('input')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  opacity: 0,
  cursor: 'pointer',
});

export const CheckIcon = styled(CheckboxCheckedIcon)({
  width: '100%',
  height: '100%',
});

export const UnCheckIcon = styled(CheckboxUnCheckedIcon)({
  width: '100%',
  height: '100%',
});

export const CheckboxLabel = styled('div')(({ theme }) => ({
  marginLeft: '8px',
  color: theme.palette.common.black,
  fontSize: '14px',
  '&[disabled]': {
    color: theme.palette.common.lightText,
  },
}));
